<template>
  <div class="swiper-box">
    <el-carousel height="450px" :interval="2000" arrow="always" class="swiper-container" >
      <el-carousel-item v-for="item in slideList" :key="item.id" class="item-swiper" >
        <a>
          <img v-bind:src="item.img" @click="skipto(item.path)"/>
        </a>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default{
  data () {
    return {
      slideList: [
        {
          id: '24',
          path: '/',
          img: require('../assets/swiper/swiper1.jpg')
        },
        {
          id: '25',
          path: '/',
          img: require('../assets/swiper/swiper2.jpg')
        },
        {
          id: '26',
          path: '/',
          img: require('../assets/swiper/swiper3.jpg')
        }
      ]
    }
  },
  methods: {
    skipto (path) {
      this.$router.push(path)
    }
  }
}
</script>

<style scoped lang='scss'>
@import "../assets/scss/base.scss";
@import "../assets/scss/mixin.scss";
@import "../assets/scss/config.scss";
.swiper-box{
  height: 450px;
  .swiper-container{
    width: 100%;
    height: 100%;
    .item-swiper {
      width: 100%;
      height: 100%;
    }
  }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 450px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  a{
    img{
      width: 100%;
      height: 450px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/swiper.vue